import Addison from "./Locations/Addison";
import ArlingtonHeights from "./Locations/ArlingtonHeights";
import Bartlett from "./Locations/Bartlett";
import Barrington from "./Locations/Barrington";
import Bolingbrook from "./Locations/Bolingbrook";
import BurrRidge from "./Locations/BurrRidge";
import CrestHill from "./Locations/CrestHill";
import ClarendonHills from "./Locations/ClarendonHill";
import Crestwood from "./Locations/Crestwood";
import Darien from "./Locations/Darien";
import DownersGrove from "./Locations/DownersGrove";
import Elmhurst from "./Locations/Elmhurst";
import ElmwoodPark from "./Locations/ElmwoodPark";
import GlenEllyn from "./Locations/GlenEllyn";
import HickoryHills from "./Locations/HickoryHills";
import Hinsdale from "./Locations/Hinsdale";
import HomerGlen from "./Locations/HomerGlen";
import Lemont from "./Locations/Lemont";
import Lisle from "./Locations/Lisle";
import Lockport from "./Locations/Lockport";
import Mokena from "./Locations/Mokena";
import Naperville from "./Locations/Naperville";
import NewLenox from "./Locations/NewLenox";
import OakBrook from "./Locations/OakBrook";
import OrlandPark from "./Locations/OrlandPark";
import PalosHeights from "./Locations/PalosHeights";
import PalosHills from "./Locations/PalosHills";
import Plainfield from "./Locations/Plainfield";
import ProspectHeights from "./Locations/ProspectHeights";
import Romeoville from "./Locations/Romeoville";
import Schaumburg from "./Locations/Schaumburg";
import Shorewood from "./Locations/Shorewood";
import VillaPark from "./Locations/VillaPark";
import Wheaton from "./Locations/Wheaton";
import WesternSprings from "./Locations/WesternSprings";
import WillowSprings from "./Locations/WillowSprings";

// [url slug, display name, component]. Slugs match your existing URLs exactly.
const pages = [
  ["addison", "Addison", Addison],
  ["arlington-heights", "Arlington Heights", ArlingtonHeights],
  ["bartlett", "Bartlett", Bartlett],
  ["barrington", "Barrington", Barrington],
  ["bolingbrook", "Bolingbrook", Bolingbrook],
  ["burr-ridge", "Burr Ridge", BurrRidge],
  ["crest-hill", "Crest Hill", CrestHill],
  ["clarendon-hill", "Clarendon Hills", ClarendonHills],
  ["crestwood", "Crestwood", Crestwood],
  ["darien", "Darien", Darien],
  ["downers-grove", "Downers Grove", DownersGrove],
  ["elmhurst", "Elmhurst", Elmhurst],
  ["elmwood-park", "Elmwood Park", ElmwoodPark],
  ["glen-ellyn", "Glen Ellyn", GlenEllyn],
  ["hickory-hills", "Hickory Hills", HickoryHills],
  ["hinsdale", "Hinsdale", Hinsdale],
  ["homer-glen", "Homer Glen", HomerGlen],
  ["lemont", "Lemont", Lemont],
  ["lisle", "Lisle", Lisle],
  ["lockport", "Lockport", Lockport],
  ["mokena", "Mokena", Mokena],
  ["naperville", "Naperville", Naperville],
  ["new-lenox", "New Lenox", NewLenox],
  ["oak-brook", "Oak Brook", OakBrook],
  ["orland-park", "Orland Park", OrlandPark],
  ["palos-heights", "Palos Heights", PalosHeights],
  ["palos-hills", "Palos Hills", PalosHills],
  ["plainfield", "Plainfield", Plainfield],
  ["prospect-heights", "Prospect Heights", ProspectHeights],
  ["romeoville", "Romeoville", Romeoville],
  ["schaumburg", "Schaumburg", Schaumburg],
  ["shorewood", "Shorewood", Shorewood],
  ["villa-park", "Villa Park", VillaPark],
  ["wheaton", "Wheaton", Wheaton],
  ["western-springs", "Western Springs", WesternSprings],
  ["willow-springs", "Willow Springs", WillowSprings],
];

export const CITY_PAGES = pages.map(([slug, name, Component]) => ({ slug, name, Component }));
export const cityPath = (slug) => `/illinois-service-area/appliance-repair-${slug}-illinois`;